<template>
  <!--联系我们 -->
  <div class="layout">
    <Layout>
      <!-- 头 -->
      <Header>
        <Menu theme="light" mode="horizontal" active-name="2-2">
          <div class="layout-logo">
            <a href="/"> <img src="../assets/logo-title-v3.png" alt="" /></a>
          </div>
          <div class="layout-nav">
            <!-- <MenuItem style="font-size: 18px !important" name="1" to="/sourceInformation">
            aa信息
            </MenuItem>
            <MenuItem to="/vehicleInformation" style="font-size: 18px !important" name="2">
            bb信息
            </MenuItem> -->
            <MenuItem to="/complaintPublicity" style="font-size: 18px !important" name="3">
            评价公示
            </MenuItem>
            <MenuItem to="/evaluationPublicity" style="font-size: 18px !important" name="4">
            投诉公示
            </MenuItem>
            <Submenu name="5">
              <template slot="title"><span style="font-size: 18px !important">联系客服</span>
              </template>
              <MenuItem to="/customerServiceContact" style="
                  font-size: 15px !important;
                  padding-left: 35px !important;
                " name="2-1">投诉建议</MenuItem>
              <MenuItem to="/contactUs" style="
                  font-size: 15px !important;
                  padding-left: 35px !important;
                " name="2-2">联系我们</MenuItem>
            </Submenu>
          </div>
        </Menu>
      </Header>
      <div class="Header-img"></div>
      <!-- 中 -->
      <Content>
        <div>
          <div id="containerAddress" class="amap-wrapper"></div>
          <div class="Content-left">
            <div class="nr">
              <div>
                <div class="nr-title">联系我们</div>
                <div style="color: #999999; font-size: 16px">Contact Us</div>
                <div class="nr-title-icon">
                  <i>
                    <img
                      style="width:20px;vertical-align:middle;height:20px;display:inline-block;color:#999999;margin-bottom:5px;"
                      src="../assets/定位.png" alt="" />
                  </i>
                  四川省成都市成华区民兴北一路14号2层A047号
                </div>
                <div class="nr-title2">全国统一咨询热线</div>
                <div style="
                    color: #333333;
                    font-size: 16px;
                    display: flex;
                    margin-left: 220px;
                  ">
                  <div>
                    <img
                      style="width:27px;vertical-align:middle;height:27px;display:inline-block;margin-right:15px;margin-bottom:5px;margin-top:15px;"
                      src="../assets/电话.png" alt="" />
                  </div>
                  <div style="font-size: 16px; font-style: italic">
                    <p style="margin-top:18px;">18752036980</p>
                    <!-- <p style="margin-top: 10px">18992857680</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>
      <!-- 尾 -->
      <Footer class="layout-footer-center">
        <div style="
            width: 100%;
            height: 100%;
            background-image: linear-gradient(#252c37, #1e252c);
          ">
          <div style="width: 100%; height: 50px"></div>

          <!-- 低 -->
          <div style="display: flex">
            <div class="Footer-text-left">拼卡卡欢迎您的加入！</div>
            <div class="Footer-text-right">
              <p class="Footer-text-title">江苏云智界科技有限公司</p>
              <!-- <p class="opt opt-let">
                <span class="title">帮助中心</span>
                <router-link class="a-link" :to="'/userGuide'">
                  用户指南
                </router-link>
              </p> -->
              <!-- <p class="opt opt-let">
                <span class="title">关于我们</span>
                <a class="a-link" href="#">联系我们</a>
              </p> -->
              <p class="opt opt-let2">
                <span style="margin-left: -1px" class="title">服务热线</span>
                <router-link class="a-link1" :to="'#'">
                  18752036980
                </router-link>
              </p>
            </div>
          </div>
          <!-- 线 -->
          <div class="Line">
            <div class="LineClik"></div>
          </div>
          <!-- 低 -->
          <div>
            <!-- <p style="line-height: 18px">
              <img src="../assets/hui.png" style="width: 18px; height: 18px; vertical-align: middle" alt="" />
              <a style="line-height: 18px; color: #ffffff"
                href="http://www.beian.gov.cn/portal/recordQuery?token=cc5dd992-aa8e-47e8-94b8-2c2e2feadf98"
                target="_blank">豫公网安备：41080039010-21001号</a>&emsp;
              <span style="color: #b4c1cd">增值电信业务经营许可证：</span>
              <a href="https://beian.miit.gov.cn/#/Integrated/index" style="line-height: 18px; color: #ffffff"
                target="_blank">豫B2-20210727</a>
            </p> -->

            <p style="padding-bottom: 20px; color: #b4c1cd">
              <!-- © Copyright 2020-2023 -->
              <span><a style="color: #ffffff" href="#">
                  江苏云智界科技有限公司
                </a></span><br />
              All Rights Reserved.
              <a style="color: #ffffff" href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank">苏ICP备2025185234号-1</a>
            </p>
            <div>
              <div style="width: 100%; height: 10px"></div>
            </div>
          </div>
        </div>
      </Footer>
    </Layout>
  </div>
</template>
<script>
import Map_location from "../assets/位置.png";
export default {
  data() {
    return {
      value1: 0,
      height: 0,
      one: false,
      criteriaIcon: true,
      map: null,
      //
      Map_location: Map_location,
    };
  },
  created() {
    // this.point();
  },
  mounted() {
    let that = this;
    var map = new AMap.Map("containerAddress", {
      zoom: 15,
      center: [104.158622, 30.683065],
    });
    var endAddressMap = new AMap.Marker({
      position: new AMap.LngLat(104.158622, 30.683065), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      icon: new AMap.Icon({
        image: Map_location,
        size: new AMap.Size(30, 30), //图标大小
        imageSize: new AMap.Size(30, 30),
      }),
    });
    map.add(endAddressMap);
    //
    var content = ["四川省成都市成华区民兴北一路14号2层A047号"];
    function createInfoWindow(content) {
      // 内容拼接 ...
      return content;
    }
    var infoWindow = new AMap.InfoWindow({
      anchor: "bottom-center",
      content: createInfoWindow(content.join("<br>")), //传入 dom 对象，或者 html 字符串
      offset: new AMap.Pixel(15, 3),
    });

    infoWindow.open(map, [104.158622, 30.683065]);
  },
  methods: {},
};
</script>
<style scoped>
.amap-wrapper {
  width: 100%;
  height: 800px;
}

.amap-box {
  width: 100%;
  height: 800px;
}

.Content-left {
  height: 800px;
  width: 40%;
  position: absolute;
  top: 89px;
  right: 0px;
  text-align: right;
  padding-right: 120px;
  border-left: 200px solid transparent;
  border-bottom: 800px solid #fff;
  z-index: 1;
}

.nr-title {
  font-size: 28px;
  color: #333333;
  padding-bottom: 20px;
  border-bottom: solid #fcad22 2px;
  margin-bottom: 20px;
  display: inline-block;
}

.nr {
  margin-top: 50%;
  /* float: right; */
  position: absolute;
  right: 120px;
  top: 50%;
}

.nr-title-icon {
  color: #666666;
  font-size: 18px;
  margin-top: 30px;
  border-bottom: solid #b2b2b2 2px;
  padding-bottom: 8px px;
}

.nr-title2 {
  color: #333333;
  font-weight: bold;
  font-size: 16px;
  margin: 15px 0 20px 0;
}

#triangle-down {
  /* width: 100%;
  height: 100%; */
  background-color: #eee;
  /* z-index: 88; */
}

/*     000000000000000000000000 */
.ivu-layout-header {
  padding: 0 !important;
  height: 89px !important;
  background: #fff !important;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 19%) !important;
}

.ivu-menu-horizontal {
  height: 89px !important;
  line-height: 89px !important;
  background: #fff !important;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 19%) !important;
}

.layout {
  /* border: 1px solid #d7dde4; */
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  /* overflow: hidden; */
}

.ivu-layout-footer {
  padding: 0 !important;
}

.layout-logo {
  width: 100px;
  height: 30px;
  /* background: #5b6270; */
  border-radius: 3px;
  float: left;
  position: relative;
  top: 30px;
  left: 30px;
}

.layout-logo img {
  height: 44px;
  position: relative;
  top: -13px;
  left: 50px;
}

.layout-nav {
  width: 650px;
  margin: 0 auto;
  margin-right: 20px;
}

.layout-footer-center {
  text-align: center;
}

.Footer-text-left {
  font-size: 40px;
  color: #065fc3;
  display: inline-block;
  font-style: italic;
  margin-left: 23%;
  margin-top: 45px;
}

.Footer-text-right {
  width: 321px;
  display: inline-block;
  margin-left: 96px;
  /* color: #ffffff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%); */
}

.Footer-text-title {
  font-size: 22px;
  margin-bottom: 10px;
  color: #fff;
}

.opt {
  line-height: 2.2;
}

.opt-let {
  margin-left: -79px;
}

.opt-let2 {
  width: 400px;
  margin-left: -59px;
  display: inline-block;
}

.title {
  font-size: 16px;
  color: #b4c1cd;
  border-right: 1px #b4c1cd solid;
  padding-right: 15px;
}

.a-link {
  font-size: 16px;
  color: #ffffff;
  margin-left: 15px;
}

.a-link1 {
  font-size: 16px;
  color: #ffffff;
  margin-left: 14px;
}

.Line {
  margin-top: 40px;
  margin-bottom: 40px;
  /* border-bottom: 1px solid #fff; */
  z-index: 9999;
}

.LineClik {
  position: relative;
  bottom: 0px;
  left: 1px;
  width: 99.5%;
  height: 1px;
  background-color: #3f4955;
}

.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  color: rgb(33, 195, 143);
  border: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/contactUs.vue